module.exports = __webpack_public_path__ + "static/media/TA.6f777b1e.svg";